import React, { useState } from "react";
import {
  TextField,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Alert,
} from "@mui/material";

function TagInput({ isVisible = false, setVisible, confirmValues }) {
  const [open, setOpen] = useState(isVisible);
  const [tagNumbers, setTagNumbers] = useState({});
  const [errors, setErrors] = useState([]);

  const _handleChange = (event) => {
    const { name, value, validity } = event.target;
    // Clearing the errors array in case some errors where triggered
    setErrors([]);
    if (validity.valid) {
      setTagNumbers({ ...tagNumbers, [name]: value });
    }
  };

  const _handleClose = () => {
    setOpen(false);
    setVisible(false);
  };

  const handleConfirm = () => {
    if (!formIsValid()) {
      return;
    }
    confirmValues(tagNumbers);
    setOpen(false);
    setVisible(false);
  };

  const formIsValid = () => {
    const errors = {};
    if (
      Object.keys(tagNumbers).length === 0 ||
      ("start" in tagNumbers && isNaN(parseInt(tagNumbers.start)))
    ) {
      errors.startRange = "The Starting Tag Number / Range is required.";
    } else if ("end" in tagNumbers && tagNumbers.end === "") {
      Object.keys(tagNumbers).forEach((key) => {
        if (tagNumbers[key] === "") delete tagNumbers[key];
      });
    } else if (
      "end" in tagNumbers &&
      (Number(tagNumbers.end) < Number(tagNumbers.start) ||
        Number.isNaN(
          Number(tagNumbers.end) || !Number.isInteger(Number(tagNumbers.end))
        ))
    ) {
      errors.endRange =
        "The Ending Tag Number / Range must be greater than the Starting one.";
    } else if ("end" in tagNumbers && !("start" in tagNumbers)) {
      errors.endRange =
        "The Starting Range must be provided when an End Range is entered.";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"xs"}
      open={open || isVisible}
      onClose={_handleClose}
    >
      <DialogTitle style={{ backgroundColor: "#0099d8" }}>
        <Typography align="center" style={{ color: "white" }}>
          Tag Number / Range Input
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box
          noValidate
          component="form"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box m={1}>
            <TextField
              autoFocus
              id="tag_range_start"
              name="start"
              label="Tag Range Start"
              type="tel"
              size="small"
              variant="standard"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: 0,
                style: { textAlign: "center" },
                pattern: "[0-9]*",
              }}
              helperText="Required Value"
              value={tagNumbers.start || ""}
              onChange={_handleChange}
            />
          </Box>
          {errors.startRange && (
            <Alert severity="error">{errors.startRange}</Alert>
          )}

          <Box m={0.5}>
            <TextField
              id="tag_range_end"
              name="end"
              label="Tag Range End"
              type="tel"
              size="small"
              variant="standard"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: 0,
                style: { textAlign: "center" },
                pattern: "[0-9]*",
              }}
              onChange={_handleChange}
              value={tagNumbers.end || ""}
            />
          </Box>
          {errors.endRange && <Alert severity="error">{errors.endRange}</Alert>}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={_handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ backgroundColor: "green" }}
          onClick={handleConfirm}
          autoFocus
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TagInput;
